export function haveSameEmailAddress(currentUser: { emailAddress?: string }, person: { emailAddress?: string }) {
  return currentUser.emailAddress === person.emailAddress
}
